
import {
    FETCH_TECHNICIAN_PARTNER,
    RESET_REFILL_PARTNER,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
  };
  
  const technicianPartnerViewReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHNICIAN_PARTNER:
        return { data: action.payload };
      case RESET_REFILL_PARTNER:
        return initialState;
      default:
        return state;
    }
  };
  
  export default technicianPartnerViewReducer;
  